import React from "react";
import { FormControlLabel, Grid, MenuItem, Switch, TextField } from "@mui/material";
import { CONTRACT_PERIODICITY_OPTIONS, CONTRACT_STATUS_OPTIONS } from "./contractFormConfig";

export default function ContractFormFields({ form, setForm, contractPlans = [] }) {
  return (
    <Grid container spacing={2} sx={{ mt: 0.5 }}>
      <Grid item xs={12} md={6}>
        <TextField
          label="Contract Number"
          fullWidth
          value={form.contract_number}
          onChange={(e) => setForm((prev) => ({ ...prev, contract_number: e.target.value }))}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          select
          label="Plan"
          fullWidth
          value={form.plan_id}
          onChange={(e) => setForm((prev) => ({ ...prev, plan_id: e.target.value }))}
        >
          <MenuItem value="">-- Select --</MenuItem>
          {(contractPlans || []).map((item) => (
            <MenuItem key={item.id} value={item.id}>
              {item.name} {item.code ? `(${item.code})` : ""}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          select
          label="Status"
          fullWidth
          value={form.status}
          onChange={(e) => setForm((prev) => ({ ...prev, status: e.target.value }))}
        >
          {CONTRACT_STATUS_OPTIONS.map((item) => (
            <MenuItem key={item.value} value={item.value}>
              {item.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField
          label="Currency"
          fullWidth
          value={form.currency}
          onChange={(e) => setForm((prev) => ({ ...prev, currency: e.target.value.toUpperCase() }))}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField
          select
          label="Periodicity"
          fullWidth
          value={form.periodicity}
          onChange={(e) => setForm((prev) => ({ ...prev, periodicity: e.target.value }))}
        >
          {CONTRACT_PERIODICITY_OPTIONS.map((item) => (
            <MenuItem key={item.value} value={item.value}>
              {item.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={12} md={4}>
        <FormControlLabel
          control={(
            <Switch
              checked={Boolean(form.auto_renew)}
              onChange={(e) => setForm((prev) => ({ ...prev, auto_renew: e.target.checked }))}
            />
          )}
          label="Auto Renew"
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField
          label="Start Date"
          type="date"
          fullWidth
          InputLabelProps={{ shrink: true }}
          value={form.start_date}
          onChange={(e) => setForm((prev) => ({ ...prev, start_date: e.target.value }))}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField
          label="Signature Date"
          type="date"
          fullWidth
          InputLabelProps={{ shrink: true }}
          value={form.signature_date}
          onChange={(e) => setForm((prev) => ({ ...prev, signature_date: e.target.value }))}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField
          label="Renewal Date"
          type="date"
          fullWidth
          InputLabelProps={{ shrink: true }}
          value={form.renewal_date}
          onChange={(e) => setForm((prev) => ({ ...prev, renewal_date: e.target.value }))}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Notes"
          fullWidth
          value={form.notes}
          onChange={(e) => setForm((prev) => ({ ...prev, notes: e.target.value }))}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Internal Note"
          fullWidth
          value={form.internal_note}
          onChange={(e) => setForm((prev) => ({ ...prev, internal_note: e.target.value }))}
        />
      </Grid>
    </Grid>
  );
}

